function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#292c2e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 7.702)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M9.5,16.86a5.11,5.11,0,1,1-5.108,5.11A5.108,5.108,0,0,1,9.5,16.86Zm0,6.654a1.542,1.542,0,1,0-1.541-1.542A1.547,1.547,0,0,0,9.5,23.514Z",
  transform: "translate(28.544 -3.012)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M.844,22.949l.836-6.8a2.5,2.5,0,0,1,2.62-2.19l1.831.1,5.684-5.121a2.975,2.975,0,0,1,1.992-.764l11.549,0a11.377,11.377,0,0,1,7.126,2.509l6.443,5.177,8.665,2.166a2.5,2.5,0,0,1,1.895,2.426v2.5a.662.662,0,0,1,.665.662v3.3a.852.852,0,0,1-.852.852H44.407c.021-.212.064-.415.064-.632a6.427,6.427,0,0,0-12.853,0,6.27,6.27,0,0,0,.065.632H18.137c.019-.212.062-.415.062-.632a6.425,6.425,0,1,0-12.85,0,5.84,5.84,0,0,0,.064.632H.85A.85.85,0,0,1,0,26.917V23.8A.842.842,0,0,1,.844,22.949ZM17.984,14.6l16.112.815-3.085-2.48A9.428,9.428,0,0,0,25.1,10.85H17.984Zm-2.676-.136V10.852H14.26a1.461,1.461,0,0,0-.982.378L9.989,14.19Z",
  transform: "translate(0 -8.177)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M25.969,16.86a5.11,5.11,0,1,1-5.108,5.11A5.108,5.108,0,0,1,25.969,16.86Zm0,6.654a1.542,1.542,0,1,0-1.542-1.542A1.544,1.544,0,0,0,25.969,23.514Z",
  transform: "translate(-14.199 -3.012)"
}))), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M44.221,14.4c.809.81,3.108,1.064,3.833-.621.792-1.836-.9-3.95-3.831-4.256a3.569,3.569,0,0,0-3.629,2C42.377,11.6,43.413,13.586,44.221,14.4Z",
  transform: "translate(-28.314 -9.339)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M26.214,9.656c-.84,1.282-3.787,2.238-5.2.226-1.537-2.193.108-5.425,3.871-6.622a4.779,4.779,0,0,1,5.3,1.633C27.875,5.492,27.054,8.374,26.214,9.656Z",
  transform: "translate(0.158 -3.016)"
}));

function SvgCarHybrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.15,
    height: 31.77,
    viewBox: "0 0 50.15 31.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarHybrid);
export default __webpack_public_path__ + "static/media/car-hybrid.925d73b8.svg";
export { ForwardRef as ReactComponent };